var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegalityIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96869 3.2915L5.85519 7.479H6.40419L4.39219 3.021H7.49869V13.4065C6.85869 13.43 3.59219 14.49 3.59219 14.49V15H12.3722V14.4555C12.3722 14.4555 9.03319 13.406 8.53019 13.406V3.021H11.5377L9.52519 7.479H10.0742L11.9607 3.2915L13.8472 7.479H14.3962L12.3722 2.996V2.479H8.99519C8.99519 1.8025 8.54169 1.25 8.01269 1.25C7.45319 1.25 7.03019 1.834 7.03019 2.479H3.59119V2.9225L1.53319 7.479H2.08219L3.96869 3.2915ZM9.49069 7.9895C9.49069 9.336 10.4247 10.6305 11.9602 10.6305C13.4612 10.6305 14.4297 9.336 14.4297 7.9895C14.4302 7.9915 9.49069 7.9915 9.49069 7.9895ZM6.36969 7.9895C6.36969 7.992 1.43019 7.992 1.43019 7.9895C1.43019 9.336 2.36419 10.6305 3.89969 10.6305C5.40119 10.6305 6.36969 9.336 6.36969 7.9895Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalityIconSvg);
export default __webpack_public_path__ + "static/media/legality-icon-svg.2a4f1ca98aa8ac773c8302c870273c57.svg";
export { ForwardRef as ReactComponent };